
// slick用
$(function() {
    $('.center-item').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		autoplaySpeed: 3000,
		autoplay: true,
		centerPadding: '10%',
		arrows: true,
		dots: false,
		prevArrow: '<div class="gallery_arrow_left"><img src="https://cdn.shopify.com/s/files/1/0597/4196/2333/files/back_icon_40a2aaac-6d7e-4f19-8263-4e5360abf36c.png?v=1663749012" width="100%"></div>',
		nextArrow: '<div class="gallery_arrow_right"><img src="https://cdn.shopify.com/s/files/1/0597/4196/2333/files/next_icon_75afe987-336b-4e8e-b005-ffe8c13805fd.png?v=1663749015" width="100%"></div>',
responsive: [
	{
	breakpoint: 640,
	settings: {
	centerPadding: '1%',
	arrows: false,
	}
	}
]	
     });
});

	$(document).ready(function(){
	$('.slick-current').addClass('is--active');
	});

	$('.center-item').on('beforeChange', function(){
	$('.slick-current').removeClass('is--active');
	});
	$('.center-item').on('afterChange', function(){
	$('.slick-current').addClass('is--active');
	});

//文字数制限
$(function() {
   var count = 10;
 $('.header_login_mypage_name').each(function() {
     var thisText = $(this).text();
      var textLength = thisText.length;
       if (textLength > count) {
          var showText = thisText.substring(0, count);
          var insertText = showText += '…';
          $(this).html(insertText);
      };
  });
});

//アコーディオンメニュー
	$(function(){
		//クリックで動く
		$('.nav-open').click(function(){
			$(this).toggleClass('active');
			$(this).next('nav').slideToggle();
		});
	});

//スムーズスクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//カート同意ボタン
$(function() {
 $('#checkout').prop("disabled", true); 
  $('#c_agree').change(function() {
        if ($(this).prop("checked")) {
            $('#checkout').addClass("checkout_active");
        } else {
            $('#checkout').removeClass("checkout_active");
        }
    });                   
}); 
             


